module.exports = __webpack_public_path__ + "img/image_part_001.2570a3c1.jpg";